import { useState, useRef, useEffect } from "react";
import { api } from "../../utils/api.js";
//import { MINUTE/* , HOUR */ } from "../../consts.js";
//import messageService from "../../utils/MessageService.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";
import eye from "../../vendor/eye.svg";
import eyeOff from "../../vendor/eye-off.svg";
import "./Auth.css";

const Auth = ({
  onLogin,
  setAdmin,
  setModer,
  setManager,
  setClient,
  setUsername,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [passShowed, setPassShowed] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const intervalRef = useRef(null);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPass = localStorage.getItem("rememberedPass");
    const savedName = localStorage.getItem("user");
    const savedRememberMe = localStorage.getItem("rememberMe") === "true";

    if (savedEmail && savedRememberMe) {
      setEmail(savedEmail);
      setPassword(savedPass || "");
      setRememberMe(true);
    }

    if (savedName) {
      try {
        const parsedName = JSON.parse(savedName);
        setUsername(parsedName);
      } catch {
        setUsername(savedName);
      }
    }
  }, [setUsername]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

/*   const tableErrorsRemainder = (data, heading) => {
    data
      .sort((a, b) => a.count - b.count)
      .forEach((i) => {
        const mess = `${heading}${i.count} отклик(а/ов) по вакансии "${i.vacancy}" компании "${i.company}"(${i.ink}) пришедшие из ${i.source} имеют проблемы в таблице ИНК.`;
        const timeout = Math.min(MINUTE * i.count, MINUTE * 10);
        messageService.addErrorMessage(mess, timeout);
      });
  }; */

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    try {
      const response = await api.post(E.AUTH, false, {
        user: { email: email?.trim(), pass: password?.trim() },
      });

      if (response.success) {
        const { user } = response.data;
        if (!user || !user.status) {
          setError("Логин или пароль введен не верно");
        } else {
          if (rememberMe) {
            localStorage.setItem("rememberedEmail", email);
            localStorage.setItem("rememberedPass", password);
            localStorage.setItem("rememberMe", "true");
          } else {
            localStorage.removeItem("rememberedEmail");
            localStorage.removeItem("rememberedPass");
            localStorage.removeItem("rememberMe");
          }

          localStorage.setItem("user", user.name);
          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("status", `${user.status}`);
          localStorage.setItem("ts", Date.now().toString());
          onLogin(true);
          setClient(user.status === 1);
          setManager(user.status === 2);
          setModer(user.status > 2);
          setAdmin(user.status > 3);
          setUsername(user.name);

/*           if (user.table_editor || user.status === 4) {
            let ts = null;
            const userTs = user.ts;

            if (userTs && new Date() - new Date(userTs) >= HOUR * 24) {
              ts = userTs;
            }
            const broken = await api.post(E.GET_TROUBLES_RESPONDS, user.status, {
              ts,
            });

            if (broken?.data?.length) {
              const totalCount = broken.data.reduce((p, i) => p + i.count, 0);
              const heading = `${
                ts ? "С момента последнего визита " : "За последние сутки "
              }`;
              const message = `${heading} ${totalCount} отклик(а/ов) по ${broken.data.length} вакансии(ям) с проблемами в таблице ИНК`;

              if (!user.table_editor) {
                messageService.addWarningMessage(message, 5000);
              } else {
                tableErrorsRemainder(broken.data, heading);
                intervalRef.current = setInterval(() => {
                  tableErrorsRemainder(broken.data, heading);
                }, HOUR);
              }
            }
          } */
        }
      } else {
        setError(response.error || "Ошибка авторизации");
      }
    } catch (err) {
      setError("Ошибка соединения с сервером");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Авторизация</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Введите ваш email"
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <label htmlFor="pass">
              <img
                src={passShowed ? eyeOff : eye}
                alt={`${passShowed ? "скрыть" : "показать"} пароль`}
                className="icon"
                onClick={() => {
                  setPassShowed(!passShowed);
                }}
              />
            </label>
            <input
              type={passShowed ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              id="pass"
              placeholder="Введите пароль"
            />
          </div>
          <div className="form-rememberer">
            <input
              id="rememberer"
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="rememberer">Запомнить меня</label>
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? "Вход..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Auth;
